import { lazy } from "react"

export const RequestQuotesPage = lazy(() => import("./RequestQuotesPage"))